export const companyList = [
    {
      id: 1,
      name:  'Nosotros',
      path: '/nosotros'
    },
    {
      id: 2,
      name:  'Destinos',
      path: '/destinos'
    },
    {
      id: 3,
      name:  'Agencias',
      path: '/agencias'
    },
    {
      id: 4,
      name:  'Servicios',
      path: '/servicios'
    },
  ]
export const agencyList = [
    {
      id: 1,
      name:  'Destinos',
      path: '/destinos'
    },
    {
      id: 2,
      name:  'Itinerarios',
      path: '/itinerarios'
    },
    {
      id: 3,
      name:  'Contáctanos',
      path: '/contactanos'
    },
    {
      id: 4,
      name:  'Blog',
      path: '/blog'
    },
  ]